
export default class Retry {
  constructor() {
    this.retryButtons = document.querySelectorAll('.js-retry-btn');

    if (this.retryButtons.length) {
      this.retryButtons.forEach(button => {
        const span = button.querySelector('span');
        button.addEventListener('click', this.initRetry.bind(this, button, span));
      });
    }
  }

  initRetry(item, span) {
    span.innerHTML = 'Retrying...';

    $.ajax({
      url: item.dataset.url,
      type: 'post',
      dataType: 'json',
      success: function(res) {
        if (res.success_path) {
          top.document.location = res.success_path;
        } else {
          top.document.location.reload();
        }
      },
    });
  }
}
